const DataCount = (props) => {
    const itemOffset = props.itemOffset;
    const items = props.items;
    
    return(
        <div>
            <p>{`Showing ${itemOffset+1} to ${(itemOffset+10)<items.length ? itemOffset+10 : items.length} of ${items.length} entries`}</p>
        </div>
    );
}

export default DataCount;
